import React, { useEffect, useState } from 'react';
import { LOGOUT } from 'ConstComponents';
import { OTPModal } from 'Components/Modal/OTPModal';
import { useLocation } from 'react-router-dom';
import {
    SendEKYCOTP as SEND_EKYC_OTP,
    ValidateEKYCOTP as VALIDATE_EKYC_OTP
} from 'Components/Api/MorePayOnboardingAPI';
import { useHistory } from 'react-router';
import { Container } from '@material-ui/core';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);
export const EKYCOTP = () => {
    const history = useHistory();
    const [openOTP, setOpenOTP] = useState(false);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [merchantCode, setMerchantCode] = useState('');
    const MerchantCode = location?.state?.MerchantCode;
    useEffect(() => {
        setLoadingOpen(true);
        SendOTP();
    }, []);

    const SendOTP = async () => {
        let RequestObj = {
            MerchantCode: MerchantCode
        };
        setMerchantCode(MerchantCode);
        setIsError(false);
        var response = await SEND_EKYC_OTP(JSON.stringify(RequestObj));
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }
        setSeverity('success');
        let data = JSON.parse(response.data);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(data.Message);

            setIsError(true);
            return;
        }
        setResponseMessage(data.Message);
        setOpenOTP(true);
    };
    const CustomOtpModal = openOTP ? (
        <OTPModal
            isOpen={openOTP}
            title="OTP"
            error={responseMessage}
            submitCallback={(value) => {
                VerifyOTP(value);
            }}
            resendCallback={(value) => {}}
            onDismissCallback={(value) => {}}
        />
    ) : null;
    const VerifyOTP = async (otpObj) => {
        setOpenOTP(false);
        const { OTP } = otpObj;
        let RequestObj = {
            OTP: OTP,
            MerchantCode: merchantCode
        };
        setLoadingOpen(true);
        var response = await VALIDATE_EKYC_OTP(JSON.stringify(RequestObj));
        setLoadingOpen(false);

        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setOpenOTP(true);
            return;
        }
        let data = JSON.parse(response.data);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(data.Message);
        setMerchantCode('');
        history.push('/RetailerDashboard');
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            {CustomOtpModal}
        </CustomContainer>
    );
};
